import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaOfferTypes } from './sagaOfferRedux';
import { push } from 'react-router-redux';
import { buildUrl, getSagaWAPUrl,getCurrentUserId } from '../../helpers/utility';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';
import ContractActions from '../sagaContract/sagaContractRedux';
import DeedActions from '../sagaDeed/sagaDeedRedux';

export function* requestOfferDetail(action) {
    const tag = '[REQUEST_OFFER_DETAIL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.GetOfferDetail, jwtToken, action.actionId, branchId, action.userId, action.propertyId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestOfferDetail response :`, response.data);
                yield put(Actions.offerDetailSuccess(response.data.result));
            } else {
                console.warn(`${tag} requestOfferDetail invalid response :`, response);
                throw new Error(JSON.stringify(response.data.error));
            }
        } else {
            throw new Error('NotLoggedIn');  // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestOfferDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.offerDetailFailure(message));
    }
}

export function* requestUpdateOfferDetail(action) {
    const tag = '[REQUEST_UPDATE_OFFER_DETAIL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (!jwtToken) {
            throw new Error('NotLoggedIn');
        }
        // validate required fields
        const result = validateRequestUpdateOfferDetail(action.offerDetail2Update);
        if (result.isValid) {
            // step 2 : validation passed..
            const offerDetail2Update = action.offerDetail2Update;
            offerDetail2Update.userId = action.userId;
            const response = yield call(API.UpdateOfferDetail, jwtToken, offerDetail2Update);
            if (response.status === 200 && response.data.statusCode === 200) {
                // yield put(Actions.updateOfferDetailSuccess(response.data.result));
                if (action.isRedirectToContract === true) {
                    yield put(push(buildUrl(`/dashboard/contract/?iframe=true&offerId=${action.offerDetail2Update.offerId}&contractId=0&propertyId=${action.offerDetail2Update.propertyId}`)));
                    //
                } else {
                    yield put(Actions.requestOfferDetail(action.actionId, action.userId, action.offerDetail2Update.propertyId));
                }
            } else {
                throw new Error(response.data.error);
            }
        } else {
            yield put(Actions.updateOfferDetailFailure(result.errorMessages));
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOfferDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOfferDetailFailure(message));
    }
}

function validateRequestUpdateOfferDetail(offerDetail2Update) {
    const result = { isValid: false, errorMessages: [] };
    if (offerDetail2Update == null) {
        result.isValid = true;
        return result;
    }
    let isValid = true;
    const errorMessage = [];
    // offer name
    if (!offerDetail2Update.name || offerDetail2Update.name.length === 0) {
        errorMessage.push('error.offerDetail.name');
        isValid = false;
    }
    if (offerDetail2Update.name && offerDetail2Update.name.length > 255) {
        errorMessage.push('error.offerDetail.name.exceedLength');
        isValid = false;
    }
    // offer price
    if (offerDetail2Update.offerPrice == null || offerDetail2Update.offerPrice <= 0) {
        errorMessage.push('error.offerDetail.price');
        isValid = false;
    }
    // offer start
    if (!offerDetail2Update.offerStart || offerDetail2Update.offerStart.length === 0) {
        errorMessage.push('error.offerDetail.offerStart');
        isValid = false;
    }
    // offer end
    if (!offerDetail2Update.offerEnd || offerDetail2Update.offerEnd.length === 0) {
        errorMessage.push('error.offerDetail.offerEnd');
        isValid = false;
    }
    result.isValid = isValid;
    result.errorMessages = errorMessage;
    return result;
}

export function* requestDeleteOfferBuyer(action) {
    const tag = '[REQUEST_DELETE_OFFER_BUYER]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.DeleteOfferBuyer, jwtToken, action.buyerId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDeleteOfferBuyer response :`, response.data);
                yield put(Actions.requestOfferDetail(action.actionId, action.userId));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDeleteOfferBuyer failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.deleteOfferBuyerFailure(message));
    }
}

export function* requestGetContactBuyerInformation(action) {
    const tag = '[REQUEST_GET_CONTACT_BUYER_INFORMATION]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.GetContactBuyerInformation, jwtToken, action.contactId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetContactBuyerInformation response :`, response.data);
                yield put(Actions.getContactBuyerInformationSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetContactBuyerInformation failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getContactBuyerInformationFailure(message));
    }
}

export function* requestCreateOffer(action) {
    const tag = '[REQUEST_CREATE_OFFER]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (!jwtToken) {
            throw new Error('NotLoggedIn');
        }
        const result = validateRequestUpdateOfferDetail(action.offer2Create);
        if (result.isValid) {
            // step 2 : validation passed..
            const response = yield call(API.CreateOffer, jwtToken, action.propertyId, action.userId, action.offer2Create);
            if (response.status === 200 && response.data.statusCode === 200 && response.data.result.actionId > 0) {
                console.log(`${tag} requestCreateOffer response :`, response.data);
                if (action.isRedirectToContract === true) {
                    yield put(push(buildUrl(`/dashboard/contract/?iframe=true&offerId=${response.data.result.offerId}&contractId=0`)));
                } else {
                    yield put(push(buildUrl(`/dashboard/contractofferdetail/${response.data.result.actionId}/${response.data.result.propertyId}?iframe=true`)));
                }
            } else {
                throw new Error(response.data.error);
            }
        }
        else {
            yield put(Actions.updateOfferDetailFailure(result.errorMessages));
        }
    }
    catch (e) {
        console.warn(`${tag} requestCreateOffer failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.createOfferFailure(message));
    }
}

export function* requestRestoreOffer(action) {
    const tag = '[REQUEST_RESTORE_OFFER]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestRestoreOffer, jwtToken, action.historyId, action.offerId, action.contractId, action.action);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRestoreOffer response :`, response.data);
                yield put(Actions.restoreOfferSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/contractofferdetail/${action.actionId}/${action.propertyId}?iframe=true`)));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRestoreOffer failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.restoreOfferFailure(message));
    }
}

export function* requestInitialCreateOffer(action) {
    const tag = '[REQUEST_INITIAL_CREATE_OFFER]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestInitialCreateOffer, jwtToken, branchId, action.userId, action.propertyId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestInitialCreateOffer response :`, response.data);
                yield put(Actions.initialCreateOfferSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestInitialCreateOffer failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.initialCreateOfferFailure(message));
    }
}

export function* requestGenerateOfferReport(action) {
    const tag = '[REQUEST_GENERATE_OFFER_REPORT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGenerateOfferReport, jwtToken, branchId, culture, action.offerId, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                const url = getSagaWAPUrl('viewReport', null, null, branchId, { reportName: 'OfferReport', resultURL: response.data.result });
                window.open(url, '_blank');
                yield put(Actions.generateOfferReportSuccess(true));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGenerateOfferReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateOfferReportFailure(message));
    }
}

export function* requestUpdateOfferDescription(action) {
    const tag = '[REQUEST_UPDATE_OFFER_DESCRIPTION]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateOfferDescription, jwtToken, action.offerDescription, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateOfferDescription response :`, response.data);
                yield put(Actions.updateOfferDescriptionSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOfferDescription failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOfferDescriptionFailure(message));
    }
}

export function* requestUpdateOfferPayment(action) {
    const tag = '[REQUEST_UPDATE_OFFER_PAYMENT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateOfferPayment, jwtToken, branchId, culture, action.offerPayment, action.actionId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateOfferPayment response :`, response.data);
                // window.top.location.href = getSagaWAPUrl('offer', 'user', 'password', 0, { actionId: action.actionId, offerId: action.offerPayment.offerId });
                yield put(Actions.updateOfferPaymentSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOfferPayment failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOfferPaymentFailure(message));
    }
}

export function* requestUpdateMortgageCancelationDate(action) {
    const tag = '[REQUEST_UPDATE_MORTGAGE_CANCELATION_DATE]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            console.log(action.cancelDate, action.offerId);
            const response = yield call(API.requestUpdateMortgageCancelationDate, jwtToken, action.cancelDate, action.offerId, action.cancelDateText);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateMortgageCancelationDate response :`, response.data);
                yield put(Actions.updateMortgageCancelationDateSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateMortgageCancelationDate failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateMortgageCancelationDateFailure(message));
    }
}

export function* requestGetPreviewTextTemplate(action) {
    const tag = '[REQUEST_GET_PREVIEW_TEXT_TEMPLATE]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetPreviewTextTemplate, jwtToken, action.pdfReportId, action.refId, action.propertyId, action.parentType, culture, branchId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPreviewTextTemplate response :`, response.data);
                yield put(Actions.getPreviewTextTemplateSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPreviewTextTemplate failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPreviewTextTemplateFailure(message));
    }
}

export function * requestUpdateSellerAndBuyerInformations(action) {
    const tag = '[REQUEST_UPDATE_SELLER_AND_BUYER_INFORMATIONS]';
    try {
       // step 1: perform input validation
       const jwtToken = yield getJwtToken();
       const branchId = yield getBranchId();
       const culture = yield select(currentLanguageRfc3066Fnc);
       const userId = getCurrentUserId();
       if (jwtToken) {
           // step 2 : validation passed..
          const response = yield call(API.requestUpdateSellerAndBuyerInformations,jwtToken,branchId,culture,userId,action.sellerAndBuyerInfo);
          if (response.status === 200 && response.data.statusCode === 200) {
            console.log(`${tag} requestUpdateSellerAndBuyerInformations response :` , response.data);
            yield put(Actions.updateSellerAndBuyerInformationsSuccess(response.data.result));
                if(action.sellerAndBuyerInfo.type === 'offer'||action.sellerAndBuyerInfo.type === 'rent_offer' ){
                    yield put(Actions.offerDetailSuccess(response.data.result));
                }else  if(action.sellerAndBuyerInfo.type === 'contract' ){
                    yield put(ContractActions.contractDetailSuccess(response.data.result));
                  
                }else  if(action.sellerAndBuyerInfo.type === 'deed' ){
                    yield put(DeedActions.getDeedDetailSuccess(response.data.result));
                    
                }

          } else {
              throw new Error(response.data.error);
          }
  
      } else {
          throw new Error('xx.yyInvalidInput'); // <-- fix me
      } 
    }
    catch (e) {
      console.warn(`${tag} requestUpdateSellerAndBuyerInformations failed with error :` , e);
      const message = e.message ? e.message : 'Failed';
      yield put(Actions.updateSellerAndBuyerInformationsFailure(message));
    }
  }
  

export default function* rootSaga() {
    yield all([
        takeLatest(SagaOfferTypes.REQUEST_OFFER_DETAIL, requestOfferDetail),
        takeLatest(SagaOfferTypes.REQUEST_UPDATE_OFFER_DETAIL, requestUpdateOfferDetail),
        takeLatest(SagaOfferTypes.REQUEST_DELETE_OFFER_BUYER, requestDeleteOfferBuyer),
        takeLatest(SagaOfferTypes.REQUEST_GET_CONTACT_BUYER_INFORMATION, requestGetContactBuyerInformation),
        takeLatest(SagaOfferTypes.REQUEST_CREATE_OFFER, requestCreateOffer),
        takeLatest(SagaOfferTypes.REQUEST_RESTORE_OFFER, requestRestoreOffer),
        takeLatest(SagaOfferTypes.REQUEST_INITIAL_CREATE_OFFER, requestInitialCreateOffer),
        takeLatest(SagaOfferTypes.REQUEST_GENERATE_OFFER_REPORT, requestGenerateOfferReport),
        takeLatest(SagaOfferTypes.REQUEST_UPDATE_OFFER_DESCRIPTION, requestUpdateOfferDescription),
        takeLatest(SagaOfferTypes.REQUEST_UPDATE_OFFER_PAYMENT, requestUpdateOfferPayment),
        takeLatest(SagaOfferTypes.REQUEST_UPDATE_MORTGAGE_CANCELATION_DATE, requestUpdateMortgageCancelationDate),
        takeLatest(SagaOfferTypes.REQUEST_GET_PREVIEW_TEXT_TEMPLATE, requestGetPreviewTextTemplate),
        takeLatest(SagaOfferTypes.REQUEST_UPDATE_SELLER_AND_BUYER_INFORMATIONS, requestUpdateSellerAndBuyerInformations),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaOffer/sagaOfferSaga.ts